import Api from './base.api';

interface IUsersApi {
  fetch: (type: string) => Promise<any>;
  add: (params: { type: string; title: string }) => Promise<any>;
  edit: (
    params: { type: string; title: string; _id: string },
    id: string
  ) => Promise<any>;
}

class UsersApi extends Api implements IUsersApi {
  fetch = () => this.request('users');

  add = (params: { type: string; title: string }) =>
    this.request('users/add', {
      method: 'post',
      body: JSON.stringify(params),
    });

  edit = (params: any, id: string) =>
    this.request(`users/${id}/edit`, {
      method: 'post',
      body: JSON.stringify(params),
    });
}

export default new UsersApi();
